
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

@Options( {
  components : {
    Header : defineAsyncComponent( () => import("@/components/Header.vue") ),
    Footer : defineAsyncComponent( () => import("@/components/Footer.vue") )
  }
} )
export default class extends Vue
{
  store = useStore( key );
  
  meta = setup( () => useMeta({
    title : [{
      content : "Aide aux propriétaires de garde meuble et de box",
      vmid    : "title",
      name    : "title"
    }],
      description : {
        content : "Formation self stockage, accompagnement propriétaires de garde meuble, audit, stop impayés des locataires, améliorer les taux de concrétisation, augmenter les ventes marchandises.",
        vmid    : "description",
        name    : "description"
      }
    }
  ) );

  success = false;
  loading = false;
  error   = "";
  
  formData = {
    name  : "",
    owner : "",
    email : "",
    phone : ""
  };

  submit( evt : any )
  {
    // Prevent double submit
    if( this.success || this.loading )
      return;

    this.loading = true;
    this.error   = "";

    let request = fetch( this.store.state.api + "adhesion", {
      method  : "POST",
      cache   : "no-cache",
      headers : {
        "Content-Type" : "application/json",
        "Accept"       : "application/json"
      },
      body    : JSON.stringify( this.formData )
    } );

    request.then( ( res ) => { return res.json(); } ).then( this.ajaxSuccess );
    request.catch( this.ajaxError );
  }

  ajaxSuccess( response : any )
  {
    if( response.data.success )
    {
      this.success = true;
      this.loading = false;
      this.error   = response.data.message;
    } else
    {
      this.ajaxError( response );
    }
  }

  ajaxError( response : any )
  {
    this.success = false;
    this.loading = false;

    if( response.data.errors )
      this.error = response.data.errors.join( "<br>" );
    else
      this.error = response.data.message;
  }
  
  mounted()
  {
    setTimeout( () => {
      this.store.state.loading = false;

      // Remove div#preload from DOM
      let preload = document.getElementById( "preload" );
      if( preload )
      {
        window.scrollTo( { top : 0 } );
        preload.remove();
      }
    }, this.store.state.delay );  }
}
